module.exports = __webpack_public_path__ + "img/demonstration.fd0b2384.png";